module.exports = __webpack_public_path__ + "img/mini-029.6e43022f.jpg";